import React from 'react'
import { useSelector } from 'react-redux'

const DefaultLayout = ({ children, ...rest }) => {
  const { dimension } = useSelector(state => state.carromm);
  let dynClassName = (dimension !== "") ? "" : "1";
  return (
    <div className={`select-vehicle-box${dynClassName}`}>
      <div className="car-tab-block">
        <div className=' vh-100 vw-97 bg-white'>
          {React.cloneElement(children, { rest })}
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout